import { RouteNavigation } from './RouteNavigation';

const LINKS = [
  { label: 'Quality Formulas', to: '/quality-formulas' },
  { label: 'Template Manager', to: '/templates' },
];

export const QualityAdjustmentNavigation: React.FC = () => (
  <RouteNavigation ariaLabel="Quality adjustment pages" links={LINKS} />
);
